import Logo from "../../components/Logo";

import { useState } from "react";

import styles from "./styles.module.css";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import CumprimentoObjetivo from "./EtapasFormulario/CumprimentoObjetivo";
import ExecucaoFisicoFinanceira from "./EtapasFormulario/ExecucaoFisicoFinanceira";
import ExecucaoReceitaDespesa from "./EtapasFormulario/ExecucaoReceitaDespesa";
import RelacaoDeBens from "./EtapasFormulario/RelacaoDeBens";
import ConciliacaoBancaria from "./EtapasFormulario/ConciliacaoBancaria";
import PagamentosEfetuados from "./EtapasFormulario/PagamentosEfetuados";

function NovaPrestacaoContas() {
  const [tabPrincipalIndex, setPrincipalTabIndex] = useState(0);
  const [disable2Tab, setDisable2Tab] = useState(true);
  const [disable3456Tab, setDisable3456Tab] = useState(true);
  const passarPaginaTabPrincipal = (step: number = 1) => {
    setPrincipalTabIndex(tabPrincipalIndex + step);
  };

  return (
    <section className={styles.cadastroPg}>
      <header>
        <Logo />
      </header>

      <main>
        <Tabs
          selectedIndex={tabPrincipalIndex}
          onSelect={(index) => setPrincipalTabIndex(index)}
        >
          <TabList>
            <Tab>1. Relatório de Cumprimento de objetivo</Tab>
            <Tab>2. Relatório de Execução Fisico-Financeira</Tab>
            <Tab>3. Demonstrativo da Execução da Receita e Despesa</Tab>
            <Tab>4. Relação de Pagamentos Efetuados</Tab>
            <Tab>5. Relação de Bens Adquiridos, Produzidos ou Construidos</Tab>
            <Tab>6. Conciliação Bancária</Tab>
          </TabList>
          <TabPanel>
            <CumprimentoObjetivo />
          </TabPanel>
          <TabPanel>
            <ExecucaoFisicoFinanceira />
          </TabPanel>
          <TabPanel>
            <ExecucaoReceitaDespesa />
          </TabPanel>
          <TabPanel>
            <PagamentosEfetuados />
          </TabPanel>
          <TabPanel>
            <RelacaoDeBens />
          </TabPanel>
          <TabPanel>
            <ConciliacaoBancaria />
          </TabPanel>
        </Tabs>
      </main>
    </section>
  );
}

export default NovaPrestacaoContas;
